import { render, staticRenderFns } from "./MapSelection.vue?vue&type=template&id=54c4b18b"
import script from "./MapSelection.vue?vue&type=script&lang=ts"
export * from "./MapSelection.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports